!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.headings = this.querySelectorAll("[data-highlighted-link-heading]"), 
      this.images = this.querySelectorAll("[data-highlighted-link-image]"), this.activeIndex = 0;
    }
    connectedCallback() {
      this.headings.length && this.images.length && this.headings.forEach(((e, t) => {
        e.addEventListener("mouseenter", (() => this.activateImage(t))), e.addEventListener("focus", (() => this.activateImage(t)));
      }));
    }
    activateImage(e) {
      this.activeIndex !== e && (this.images[this.activeIndex] && (this.images[this.activeIndex].classList.add("hidden"), 
      this.headings[this.activeIndex].classList.remove("desktop:italic", "desktop:!text-scheme-links")), 
      this.images[e] && (this.images[e].classList.remove("hidden"), this.headings[e].classList.add("desktop:italic", "desktop:!text-scheme-links")), 
      this.activeIndex = e);
    }
  }
  customElements.get("highlighted-links") || customElements.define("highlighted-links", e);
}();